import {Api} from "laravel-request";

import type { BindClientParams } from "../types/api.types";
import type { LaravelQueryBuilder } from "../types/laravelRequest";
import {
    ResponseOnLaravelRequestSuccess,
} from "../types/responseTypes";

export const getEmployees = (
    callbackOnSuccess: (response: ResponseOnLaravelRequestSuccess) => void,
    callbackOnError?: (xhr: XMLHttpRequest, responseData: any) => void
) => {
    return Api.get('employee', 'index')
        .whereHas('roles', (query: LaravelQueryBuilder) => query.where('slug', 'manager').orWhere('slug', 'owner'))
        .all(
            (response) => callbackOnSuccess && callbackOnSuccess(response),
            (error: XMLHttpRequest, responseData: any) => callbackOnError && callbackOnError(error, responseData)
        );
};

export const bindClient = (
    accountsToBind: any[],
    queryParamsList: BindClientParams["queryParamsList"],
    _shareUser: boolean = false
) => {
    const boundClientsList = (list: Record<string, any>, entryToAdd: any[]) => ({
        ...list,
        services: entryToAdd,
    });
    return Api.post(
        'client',
        'bind',
        accountsToBind.length > 0 ? boundClientsList(queryParamsList, accountsToBind) : queryParamsList
    );
};
